<template>
  <div class="browse-organizations">
    <organization-tile
      v-for="organization in organizations"
      :loading="loading"
      :key="organization.id"
      :organization="organization"
      @requestMembership="requestMembership" /> 
    <h1 v-if="organizations.length === 0">No organizations found</h1>
  </div>
</template>

<script>
import OrganizationTile from './OrganizationTile'

export default {
  name: 'BrowseOrganizations',
  components: { OrganizationTile },
  props: {
    organizations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {},
  methods: {
    async requestMembership (organization) {
      this.loading = true
      const requestData = { userId: this.$auth.user.id, pending: true, invite: false }
      const response = await this.$http.post(this.$api.organizations.users.create(organization.id), requestData)
      this.$emit('requestMembershipSuccess', organization, true, true, false)
      this.$message.success('Membership request sent')
      this.loading = false
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>
  h1 {
    text-align: center;
    width: 100%;
    margin-top: 100px;
    font-size: 24px;
    color: $text-light;
  }

  .browse-organizations {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: -0.66%;
    margin-right: -0.66%;

    @include breakpoint (xs) {
      margin: 0px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/user/BrowseOrganizations.vue